import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { PATCH_ZWAVE_DEVICE } from '@app/constants/myDevices/zwaveDevices'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestDone, apiRequestFailed, apiRequestSent } from '@app/actions/apiRequest'
import Api from '@app/api/myDevices/deviceSettings/zwaveDevices'
import { setMyDevices } from '@app/actions/myDevices/myDevices'

const patchZwaveDeviceLogic = createLogic({
  type: PATCH_ZWAVE_DEVICE,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token } } } = getState()
    const { myDevices: { myDevices: { devices } } } = getState()
    if (!action.data.id) {
      const { myDevices: { myDevices: { deviceToAddInfo: { id } } } } = getState()
      next({
        ...action,
        data: {
          ...action.data,
          id,
        },
        token,
        devices,
      })
    } else {
      next({
        ...action,
        token,
        devices,
      })
    }
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(PATCH_ZWAVE_DEVICE))
    try {
      const patchedDevice = await Api.patchZwaveDeviceStatus(action.token, action.data.id, action.data)
      const updatedDevices = action.devices.map((device) => ((device.id === patchedDevice.data.zwave_device.id
        && device.device_type === patchedDevice.data.zwave_device.device_type)
        ? { ...device, ...patchedDevice.data.zwave_device }
        : device))
      dispatch(setMyDevices(updatedDevices))
      dispatch(apiRequestDone(PATCH_ZWAVE_DEVICE))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('PATCH_ZWAVE_DEVICE failed without error')
      }
    }
    done()
  },
})

export default patchZwaveDeviceLogic
